const home = {
  hero: {
    eyebrow: 'Vinski Vrh · Miklavž pri Ormožu',
    title: 'Črna Kuhna',
    tagline: 'Aus dem Feuer. Aus Prlekija. Für die gemeinsame Tafel.',
    lead: 'Ein Restaurant, in dem alles im Backofen beginnt — saisonale prlekische Küche, Hausweine und Gastfreundschaft an der gemeinsamen Tafel.',
    ctaReserve: 'Tisch reservieren',
    ctaMenu: 'Speisekarte ansehen',
    linksNote: 'Klicken Sie unten auf die Links für weitere Informationen',
    photoLabel: 'Platz für das Titelbild — der Backofen oder die Zubereitung von Speisen',
    scrollHint: 'Scrollen',
  },
  fire: {
    label: 'Feuer',
    title: 'Kochen, das beim Feuer beginnt',
    text: 'Im Herzen unserer Küche steht der Backofen. Die Wärme der Glut, langsames Braten und der Duft, der den Raum erfüllt — alles, was auf den Tisch kommt, trägt eine Spur des Feuers.',
    photoLabel: 'Foto — Feuer im Backofen',
  },
  grill: {
    label: 'Grill',
    title: 'Kochen über offenem Feuer',
    text: 'Manche Gerichte brauchen nichts als Feuer, Glut und Geduld. Auf dem offenen Grill garen Fleisch und Gemüse langsam, während der Rauch die letzte Geschmacksschicht hinzufügt.',
    photoLabel: 'Foto — ein Grill mit offenem Feuer',
  },
  seasonal: {
    label: 'Jahreszeiten',
    title: 'Was die Jahreszeit gibt',
    text: 'Die Küche folgt den Jahreszeiten und dem prlekischen Boden. Wir wählen die Zutaten, wenn sie am besten sind, deshalb ändert sich die Speisekarte im Laufe des Jahres.',
    photoLabel: 'Foto — saisonale Zutaten',
  },
  dishes: {
    label: 'Vom Tisch',
    title: 'Ausgewählte Gerichte',
    text: 'Die Gerichte, die wir zubereiten, entstehen aus dem Feuer, der Saison und der heimischen Tradition. Wir sagen Ihnen genau, was auf dem Teller ist — ohne Erfindungen.',
    ctaMenu: 'Speisekarte ansehen',
    note: 'Die saisonale Speisekarte ändert sich. Prüfen Sie das aktuelle Angebot telefonisch.',
    photoLabel: 'Foto — ein Gericht vom Tisch',
  },
  wines: {
    label: 'Im Glas',
    title: 'Hausweine Glavinič',
    text: 'Der beste Wein zum Essen ist der, der direkt daneben wächst. Deshalb servieren wir die Hausweine Glavinič aus den prlekischen Weinbergen.',
    ctaWines: 'Mehr über die Weine',
    photoLabel: 'Foto — ein Glas Wein oder die Weinberge',
  },
  space: {
    label: 'Raum',
    title: 'Der Raum und das Erlebnis',
    text: 'Ein gastlicher Ort, an dem der Tisch geteilt, das Glas eingeschenkt und der Tag langsamer wird. Die prlekische Landschaft gehört zu jedem Besuch.',
    photoLabel: 'Foto — der Raum oder das Interieur',
    feature1: 'Ein Tisch, der unter Gästen geteilt wird',
    feature2: 'Ein Glas, das zum richtigen Gericht eingeschenkt wird',
    feature3: 'Zeit, die im Gespräch stehen bleibt',
  },
  galleryPreview: {
    label: 'Eindrücke',
    title: 'Von unserem Tisch und aus unserem Raum',
    text: 'Ein paar Eindrücke aus der Črna Kuhna — Feuer, Gerichte, Raum und Wein. Mehr Fotos finden Sie in der Galerie.',
    cta: 'Zur Galerie',
  },
  location: {
    label: 'Standort',
    title: 'Zwischen den Weinbergen von Prlekija',
    text: 'Sie finden uns in Vinski Vrh bei Miklavž pri Ormožu, zwischen Hügeln und Weinbergen. Der Button unten öffnet die Route zu uns.',
    ctaDirections: 'Route öffnen',
    photoLabel: 'Foto — Weinberge oder Landschaft',
  },
  hours: {
    label: 'Winteröffnungszeiten',
    title: 'Winteröffnungszeiten',
    note: 'Für größere Gruppen und besondere Anlässe rufen Sie uns bitte an.',
    rows: [
      { day: 'Montag–Donnerstag', time: 'Geschlossen' },
      { day: 'Freitag–Samstag', time: '12:00–22:00' },
      { day: 'Sonntag', time: '12:00–17:00' },
    ],
  },
  reserve: {
    label: 'Reservierung',
    title: 'Kommen Sie an die gemeinsame Tafel',
    text: 'Einen Tisch reservieren Sie schnell — online, telefonisch oder per E-Mail. Wir freuen uns auf Ihren Besuch.',
    cta: 'Tisch reservieren',
    callLabel: 'Telefon',
    emailLabel: 'E-Mail',
  },
};

export default { home };